export const defaultRowHeight = 25;
export const doubleRowHeight = 45;
export const nextRowHeight = 24;
export const defaultRowPadding = 10;
export const densityRowPadding = 4;
